$(document).on('click', 'a[href^="#"]', function (event) {
    event.preventDefault();
    const scrollHeight = $($.attr(this, 'href')).offset().top - 100;
    $('html, body').animate({
        scrollTop: scrollHeight
    }, 500);
});
